import { dm } from '#/dict/dict-manager'

type MenuBadgeCode = 'bm_admin_monitor' | 'landing_domain_monitor'

const data = {
  landing_domain_monitor: {
    label: '投放URL监控',
    path: '/landing-url-monitor',
    value: 'landing_domain_monitor',
  },
  bm_admin_monitor: {
    label: 'BM管理员监控',
    path: '/bm-admin-monitor',
    value: 'bm_admin_monitor',
  },
} satisfies Record<
  MenuBadgeCode,
  { label: string; path: string; value: MenuBadgeCode }
>

export const useMenuBadgeDict = dm.defineDict('MENU_BADGE', {
  data,
  remote: false,
  extra: (dict) => ({ ...dict, menus: Object.values(data) }),
})
